import firebase from "firebase";
//import Vue from "vue";

import { Dispatcher } from "@/store/helper/firestore";
import Vue from "vue";
import * as AIM_IDS from "@/utils/AuditItemListManipulatorIds";
import { api as appApi } from "@/store/modules/app";
import { api as auditApi } from "@/store/modules/audit";

export const api = {
  namespace: "configuration",
  actions: {
    loadData: "loadData",
    importData: "importData",
    updateConfiguration: "updateConfiguration"
  },
  mutations: {
    resetState: "resetState",
    setState: "setState",
    updateConfiguration: "updateConfiguration"
  },
  getters: {
    app: "app",
    scopes: "scopes",
    template: "template",
    audit: "audit",
    audititem: "audititem",
    finding: "finding",
    measure: "measure",
    user: "user",
    categories: "categories",
    lists: "lists",
    getCategory: "getCategory",
    getSubcategory: "getSubcategory",
    getWorkflowForComponent: "getWorkflowForComponent",
    getConfigurationForList: "getConfigurationForList",
    customerLogo: "customerLogo",
    hasPdfPreview: "hasPdfPreview",
    getFindingsOrder: "getFindingsOrder",
    getFindingTypes: "getFindingTypes",
    getWeightRanges: "getWeightRanges",
    getFindingActions: "getFindingActions",
    getAuditItemActions: "getAuditItemActions",
    getTemplateItemActions: "getTemplateItemActions",
    getDeactivatedAuditItemActions: "getDeactivatedAuditItemActions",
    getMeasureActions: "getMeasureActions"
  },
  state: {
    app: "app",
    scopes: "scopes",
    template: "template",
    audit: "audit",
    audititem: "audititem",
    finding: "finding",
    measure: "measure",
    user: "user",
    workflow: "workflow",
    categories: "categories",
    lists: "lists"
  }
};

const defaultState = () => {
  return {
    [api.state.app]: {
      components: {
        debug: true,
        search: false,
        googlelogin: false,
        dashboard: {
          activitystream: true,
          audits: false,
          favorites: false,
          measures: false
        }
      }
    },
    [api.state.audit]: {
      data: {
        scopes: [
          "Global",
          "Werk Ansbach",
          "Werk Gladbach",
          "Deutschland",
          "Region Asien",
          "Region USA"
        ],
        types: ["Prozessaudit", "Systemaudit", "Produktaudit"],
        processes: [
          "Produktentwicklung",
          "Vertrieb",
          "Produktion",
          "Service",
          "Marketing",
          "Allgemein"
        ],
        status: [
          { id: 1, description: "Neu" },
          { id: 2, description: "Geplant" },
          { id: 3, description: "Durchgeführt" },
          { id: 4, description: "Nachbereitet" },
          { id: 5, description: "Abgeschlossen" },
          { id: 6, description: "Archiviert" }
        ],
        auditparties: ["Intern", "Extern", "Lieferant"],
        // TODO: Computing!!!
        standards: [
          "ISO9001",
          "ISO14001",
          "ISO27001",
          "EU-DGSVO",
          "ISO50001",
          "VDA-6-3",
          "HACCP"
        ],
        importance: [
          { id: "", description: "Nicht definiert" },
          { id: "0", description: "Notiz" },
          { id: "1", description: "Anmerkung" },
          { id: "3", description: "Wichtige Frage" },
          { id: "9", description: "Sehr wichtige Frage" }
        ]
      },
      dialog: {
        auditname: true,
        standard: true,
        type: true,
        process: true,
        audited_by: true,
        interestedparties: false,
        scope: true,
        leadauditor: true,
        coauditors: true,
        responsible: true,
        auditors: true,
        audit_participants: true,
        planning_year: true,
        planning_date: true,
        auditing_date: true
      },
      matrix: {
        auditname: true,
        standard: true,
        type: true,
        audited_by: true,
        process: true,
        interestedparties: true,
        scope: true,
        auditor: true,
        audit_participants: true,
        planning_date: true,
        auditing_date: true,
        edit: true,
        headers: [
          {
            text: "Audit-Name",
            align: "left",
            sortable: true,
            value: "name"
          },
          { text: "Standard", value: "standard" },
          { text: "Type", value: "type" },
          { text: "Type2", value: "audited_by" },
          { text: "Scope", value: "scope" },
          { text: "Auditoren", value: "auditor" },
          { text: "Planning Date", value: "planning_date" },
          { text: "Auditing Date", value: "auditing_date" },
          { text: "Actions", value: "name", sortable: false }
        ],
        currentYear: "2019"
      },
      workflow: {
        status: [
          { id: "1", description: "New" },
          { id: "2", description: "Preparation" },
          { id: "3", description: "Execution" },
          { id: "4", description: "Wrap Up" },
          { id: "5", description: "Reporting" },
          { id: "6", description: "Completed" }
        ],
        transitions: [
          { id: "1", description: "Created", from: "1", to: "2" },
          { id: "2", description: "Prepared", from: "2", to: "3" },
          { id: "3", description: "Executed", from: "3", to: "4" },
          { id: "4", description: "Ready for Reporting", from: "4", to: "5" },
          { id: "5", description: "Completed", from: "5", to: "6" }
        ]
      },
      preparation: {
        grouped: true,
        groups: [
          {
            name: "Kategorie",
            field: "question.category"
          },
          {
            name: "Bedeutsamkeit",
            field: "question.importance"
          },
          {
            name: "Auditor",
            field: "question.auditor"
          }
        ]
      }
    },
    [api.state.audititem]: {
      data: {
        importance: [
          { id: "", description: "Nicht definiert" },
          { id: "0", description: "Notiz" },
          { id: "1", description: "Anmerkung" },
          { id: "3", description: "Wichtige Frage" },
          { id: "9", description: "Sehr wichtige Frage" }
        ],
        categories: [
          "Allgemeines",
          "Prozesstreue",
          "Verantwortung der Leitung",
          "Mitarbeiterbefähigung",
          "Produktivität"
        ],
        subcategories: ["1", "2", "3"]
      },
      dialog: {
        category: true,
        subcategory: true,
        chapters: true,
        importance: true,
        auditors: true,
        questioning_date: false,
        processes: false,
        question: true
      },
      audititemrow_component: {
        importance: true,
        category: true,
        subcategory: true,
        chapters: true,
        auditors: true,
        questioning_date: false,
        processes: false,
        question: true
      },
      preparation: {
        // TODO: Macht das hier sinn?
        grouped: true
      }
    },
    // TODO: Logische Verknüpfung eher mit den Audits?
    [api.state.finding]: {
      data: {
        importance: [
          { id: "0", description: "Bemerkung" },
          { id: "1", description: "Anmerkung" },
          { id: "3", description: "Nebenabweichung" },
          { id: "9", description: "Hauptabweichung" }
        ]
      },
      dialog: {
        audititem: true,
        importance: true,
        finding: true,
        reason: true,
        solution: true,
        geolocation: true,
        media: true
      },
      finding_component: {}
    },
    [api.state.measure]: {
      data: {},
      dialog: {},
      matrix_component: {},
      measure_component: {
        workflow: ["Offen", "In Wirksamkeitsprüfung", "Abgeschlossen"]
      },
      workflow: {
        status: [
          { id: "1", description: "Neu" },
          { id: "2", description: "Offen" },
          { id: "3", description: "In Bearbeitung" },
          { id: "4", description: "Abgeschlossen" },
          { id: "5", description: "In Wirksamkeitsprüfung" },
          { id: "6", description: "Wirksam" }
        ],
        transitions: [
          { id: "1", description: "Created", from: "1", to: "2" },
          { id: "2", description: "Prepared", from: "2", to: "3" },
          { id: "3", description: "Executed", from: "3", to: "4" },
          { id: "4", description: "Ready for Reporting", from: "4", to: "5" },
          { id: "5", description: "Completed", from: "5", to: "6" }
        ]
      }
    },
    [api.state.workflow]: {
      status: [
        { id: "1", description: "New" },
        { id: "2", description: "Preparation" },
        { id: "3", description: "Execution" },
        { id: "4", description: "Wrap Up" },
        { id: "5", description: "Reporting" },
        { id: "6", description: "Completed" }
      ],
      transitions: [
        { id: "1", description: "Created", from: "1", to: "2" },
        { id: "2", description: "Prepared", from: "2", to: "3" },
        { id: "3", description: "Executed", from: "3", to: "4" },
        { id: "4", description: "Ready for Reporting", from: "4", to: "5" },
        { id: "5", description: "Completed", from: "5", to: "6" }
      ]
    },
    [api.state.categories]: {
      default: [
        {
          id: "1",
          name: "Ver-Allgemeinertes",
          subcategories: [
            {
              id: "1",
              name: "Allgemeines Supershit Zeugs"
            },
            {
              id: "2",
              name: "Supershit is going to go well!"
            }
          ]
        },
        {
          id: "2",
          name: "Besonderes"
        },
        {
          id: "3",
          name: "Produktivität"
        }
      ],
      iso9001: [
        {
          id: "1",
          name: "Allgemeines",
          subcategories: [
            {
              id: "1",
              name: "Allgemeines Supershit Zeugs"
            },
            {
              id: "2",
              name: "Supershit is going to go well!"
            }
          ]
        },
        {
          id: "2",
          name: "Besonderes"
        },
        {
          id: "3",
          name: "Produktivität"
        }
      ]
    },
    [api.state.scopes]: {
      default: [
        { site: "pp3", region: "AC", division: "AC" },
        { site: "xs1", region: "AC", division: "AC" },
        { site: "gobd", region: "EMEA", division: "KB" },
        { site: "rob", region: "EMEA", division: "IS" },
        { site: "ru3", region: "EMEA", division: "IS" },
        { site: "go1", region: "EMEA", division: "BS" },
        { site: "mun", region: "EMEA", division: "IS" },
        { site: "roh", region: "EMEA", division: "AC" },
        { site: "faz", region: "AC", division: "AC" },
        { site: "zeit", region: "EMEA", division: "BS" },
        { site: "wirt", region: "EMEA", division: "WS" },
        { site: "anon", region: "EMEA", division: "KB" },
        { site: "zton", region: "EMEA", division: "WS" },
        { site: "ssid", region: "EMEA", division: "IS" },
        { site: "gudt", region: "AC", division: "AC" },
        { site: "rohr", region: "EMEA", division: "KB" },
        { site: "mungo", region: "AM", division: "IS" },
        { site: "rusl", region: "AM", division: "IS" },
        { site: "stan", region: "AC", division: "AC" },
        { site: "füss", region: "AC", division: "AC" },
        { site: "rud", region: "AP", division: "KB" },
        { site: "berl", region: "AC", division: "AC" },
        { site: "akkd", region: "AP", division: "IS" },
        { site: "rund", region: "AC", division: "AC" },
        { site: "mast", region: "EMEA", division: "BS" }
      ]
    },
    [api.state.user]: {
      data: {
        groups: [
          { id: "user", name: "User" },
          { id: "auditor", name: "Auditor" },
          { id: "admin", name: "Admin" },
          { id: "measure-dispatcher", name: "Maßnahmenverantwortliche" }
        ]
      },
      dialog: {
        avatar: true,
        name: true,
        email: true,
        groups: true,
        googlelogin: false
      },
      matrix: {
        avatar: false,
        name: true,
        email: true,
        groups: true,
        actions: true
      }
    },
    [api.state.lists]: null
  };
};

const state = defaultState();

const mutations = {
  [api.mutations.resetState](state) {
    Object.assign(state, defaultState());
  },
  [api.mutations.setState](state, payload) {
    Object.assign(state, payload);
  },
  [api.mutations.updateConfiguration](state, payload) {
    if (payload.segment in state && state[payload.segment]) {
      Object.assign(state[payload.segment], payload.data);
    } else {
      Vue.set(state, payload.segment, payload.data);
    }
  }
};

// TODO: Not realy save...
const actions = {
  [api.actions.loadData]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      dispatch("app/setLoading", false, { root: true });
      firebase
        .firestore()
        .collection("configuration")
        .get()
        .then(snapshot => {
          const configurations = {};
          snapshot.forEach(doc => {
            console.log("Configuration", doc.id, doc.data());
            configurations[doc.id] = doc.data();
          });
          console.log("Fetch config data from firebase");
          commit("setState", configurations);
          dispatch("app/setLoading", false, { root: true });
          resolve(true);
        })
        .catch(error => {
          console.log(error);
          dispatch("app/setLoading", false, { root: true });
          reject(false);
        });
    });
  },
  [api.actions.importData]({ commit }, payload) {
    console.log("importData", commit);
    // TODO: Datensätze aus Configuration Component importieren -> Hier verliert man schon schnell den Überblick!
    // const ref = "configuration";
    // const mutation = "resetState";

    let daten = defaultState();
    console.log("Import Default State to firebase", daten);

    payload = { data: defaultState() };

    console.log("Payload", payload);

    // Disabled - Ist viel zu gefährlich!
    //Dispatcher.importAsync({ ref, child, payload, commit, mutation });
  },
  [api.actions.updateConfiguration]({ commit }, payload) {
    // TODO: Datensätze aus Configuration Component importieren -> Hier verliert man schon schnell den Überblick!
    const ref = "configuration";
    const mutation = "updateConfiguration";
    const doc = payload.segment;
    const child = "";

    console.log("Payload", payload);

    Dispatcher.createAsync({ ref, doc, child, payload, commit, mutation });
  }
};

const getters = {
  [api.getters.app](state) {
    return state.app;
  },
  [api.getters.audit](state) {
    return state.audit;
  },
  [api.getters.audititem](state) {
    return state.audititem;
  },
  [api.getters.finding](state) {
    return state.finding;
  },
  [api.getters.measure](state) {
    return state.measure;
  },
  [api.getters.scopes](state) {
    return state.scopes;
  },
  [api.getters.user](state) {
    return state.user;
  },
  [api.getters.categories](state) {
    return state.categories;
  },
  [api.getters.lists](state) {
    return { ...defaultgetConfigurationForList(), ...state.lists };
  },
  [api.getters.getCategory](state) {
    return objectId => {
      if (typeof objectId === "string") {
        objectId = objectId.toLocaleLowerCase();
      } else {
        objectId = "default";
      }
      if (state.categories[objectId]) {
        console.debug("Load XY category");
        return state.categories[objectId];
      } else {
        console.debug(state.categories["default"]);
        return state.categories["default"];
      }
    };
  },
  [api.getters.getSubcategory](state) {
    return objectId => {
      if (state.categories[objectId]) {
        let result = {};
        let categories = { ...state.categories[objectId] };

        for (let key in categories) {
          if (categories[key].subcategories) {
            result[key] = categories[key].subcategories;
          }
        }
      } else {
        let result = {};
        let categories = { ...state.categories["default"] };

        for (let key in categories) {
          if (categories[key].subcategories) {
            result[key] = categories[key].subcategories;
          }
        }
      }
    };
  },
  [api.getters.getWorkflowForComponent](state) {
    return ComponentName => {
      if (
        typeof state[ComponentName] === "object" &&
        typeof state[ComponentName].workflow === "object" &&
        state[ComponentName].workflow.status instanceof Array &&
        state[ComponentName].workflow.transitions instanceof Array
      ) {
        return state[ComponentName].workflow;
      } else {
        console.error("Invalid Workflow for Component", ComponentName, state);
        return { status: [], transitions: [] };
      }
    };
  },
  [api.getters.getConfigurationForList](state, getters) {
    return key => {
      if (key in getters.lists && getters.lists[key]) {
        return getters.lists[key];
      } else {
        return {
          pageSizes: [25, 50, 100, null],
          itemsjs: null,
          manipulators: null
        };
      }
    };
  },
  [api.getters.customerLogo](state) {
    return (
      state.app.customerLogo ||
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVR42mNgAAIAAAUAAen63NgAAAAASUVORK5CYII="
    );
  },
  [api.getters.hasPdfPreview](state) {
    const featureName = "pdfPreview";
    return state.app.features
      ? featureName in state.app.features && state.app.features[featureName]
      : false;
  },
  [api.getters.getFindingsOrder](state) {
    const finding_data = state.finding.data;

    if (finding_data.importance_order) {
      return finding_data.importance_order;
    } else {
      console.warn("Findings order is not defined use generic fallback");
      const importance_order = finding_data.importance.map(v => v.id);
      importance_order.push(null);
      return importance_order;
    }
  },
  [api.getters.getFindingTypes](state) {
    const finding_types = state.finding.data.importance;

    return finding_types;
  },
  [api.getters.getWeightRanges](state) {
    const empty_range = () => ({
      min: Number.MAX_SAFE_INTEGER,
      max: Number.MIN_SAFE_INTEGER
    });

    const range_extract = (prev, type) => {
      if (typeof type.value === "number") {
        return {
          min: Math.min(prev.min, type.value),
          max: Math.max(prev.max, type.value)
        };
      } else {
        console.warn("Ignored type weight", type);
        return prev;
      }
    };
    const finding_weight_range = state.finding.data.importance.reduce(
      range_extract,
      empty_range()
    );
    const criteria_weight_range = state.audititem.data.importance.reduce(
      range_extract,
      empty_range()
    );

    return {
      criteria: criteria_weight_range,
      finding: finding_weight_range
    };
  },
  [api.getters.getFindingActions](state, getters, rootState, rootGetters) {
    console.log(api.getters.getFindingActions, rootGetters);
    const isOnline =
      rootGetters[[appApi.namespace, appApi.getters.getIsOnline].join("/")];
    const actions = [];

    actions.push({
      id: "1",
      color: "blue darken-2",
      icon: "edit",
      event: "itemupdate"
    });
    if (isOnline) {
      actions.push({
        id: "2",
        color: "indigo",
        icon: "camera",
        event: "itemcamera"
      });
      actions.push({
        id: "3",
        color: "indigo",
        icon: "attach_file",
        event: "itemattach"
      });
    }

    actions.push({
      id: "4",
      color: "red",
      icon: "delete",
      event: {
        action: [auditApi.namespace, auditApi.actions.deleteDeviation].join("/")
      }
    });
    return actions;
  },
  [api.getters.getAuditItemActions]() {
    return [
      {
        id: "1",
        color: "blue darken-2",
        icon: "edit",
        event: "itemupdate"
      },
      {
        id: "2",
        color: "red",
        icon: "delete",
        event: "itemdelete"
      }
    ];
  },
  [api.getters.getTemplateItemActions](state, getters) {
    return getters[api.getters.getAuditItemActions];
  },
  [api.getters.getDeactivatedAuditItemActions]() {
    return [
      {
        id: "1",
        color: "blue darken-2",
        icon: "undo",
        event: {
          action: [
            auditApi.namespace,
            auditApi.actions.reactivateAuditItem
          ].join("/")
        }
      }
    ];
  },
  [api.getters.getMeasureActions]() {
    return [
      {
        id: "1",
        color: "blue darken-2",
        icon: "edit",
        event: "itemupdate"
      },
      {
        id: "2",
        color: "red",
        icon: "delete",
        event: "itemdelete"
      }
    ];
  }
};

export default {
  namespaced: true,
  api,
  state,
  actions,
  getters,
  mutations
};

function defaultgetConfigurationForList() {
  return {
    users: {
      pageSizes: [100, 200, 500, null],
      itemsjs: null,
      manipulators: null
    },
    templatematrix: {
      pageSizes: [25, 50, 100, null],
      itemsjs: null,
      manipulators: null
    },
    templateselection: {
      pageSizes: [null],
      itemsjs: null,
      manipulators: null
    },
    auditmatrix: {
      pageSizes: [25, 50, 100, null],
      itemsjs: {
        searchableFields: ["title", "standard", "auditor"],
        sortings: {
          name_asc: {
            field: "name",
            order: "asc"
          }
        },
        aggregations: {
          standard: {
            title: "Standard",
            conjunction: false,
            size: 200
          },
          type: { title: "Audittyp", conjunction: false, size: 10 },
          audited_by: {
            title: "Auditart",
            conjunction: false,
            size: 10
          },
          /*scope: { title: "Bereich", size: 20 },*/
          leadauditor: {
            title: "Leadauditor",
            conjunction: false,
            size: 100
          },
          planning_year: {
            title: "Planjahr",
            conjunction: false,
            size: 10
          },
          status: {
            title: "Status",
            conjunction: false,
            size: 10
          }
        }
      },
      manipulators: null
    },
    measures: {
      pageSizes: [100, 200, 500, null],
      itemsjs: {
        searchableFields: [
          "text",
          "autor",
          "audit_name",
          "assignedTo",
          "status"
        ],
        sortings: {
          name_asc: {
            field: "text",
            order: "asc"
          }
        },
        aggregations: {
          autor: { title: "Autor", conjunction: false, size: 200 },
          audit_name: { title: "Audit", conjunction: false, size: 200 },
          assignedTo: { title: "Zugewiesen an", conjunction: false, size: 10 },
          //dueDate: { title: "Zu erledigen bis", size: 10 },
          status: { title: "Status", conjunction: false, size: 20 }
        }
      },
      manipulators: null
    },
    auditActionlist: {
      pageSizes: [25, 25, 100, null],
      itemsjs: {
        searchableFields: [
          "text",
          "autor",
          "audit_name",
          "assignedTo",
          "status"
        ],
        sortings: {
          name_asc: {
            field: "text",
            order: "asc"
          }
        },
        aggregations: {
          autor: { title: "Autor", conjunction: false, size: 200 },
          audit_name: { title: "Audit", conjunction: false, size: 200 },
          assignedTo: { title: "Zugewiesen an", conjunction: false, size: 10 },
          //dueDate: { title: "Zu erledigen bis", size: 10 },
          status: { title: "Status", conjunction: false, size: 20 }
        }
      },
      manipulators: null
    },

    auditPreperation: {
      pageSizes: [25, 50, 100, null],
      itemsjs: null,
      manipulators: {
        availableFilter: [
          AIM_IDS.FILTER_IMPORTANCE,
          AIM_IDS.FILTER_CATEGORY,
          AIM_IDS.FILTER_CHAPTER
        ],
        availableSortings: [
          AIM_IDS.SORT_IMPORTANCE,
          AIM_IDS.SORT_CATEGORY,
          AIM_IDS.SORT_CHAPTER,
          AIM_IDS.SORT_NO
        ],
        availableGrouping: [
          AIM_IDS.GROUP_CATEGORY,
          AIM_IDS.GROUP_IMPORTANCE,
          AIM_IDS.GROUP_CHAPTER
        ],
        defaultSorting: [
          {
            id: AIM_IDS.SORT_NO,
            desc: false
          }
        ],
        defaultGrouping: {
          id: AIM_IDS.GROUP_CATEGORY,
          desc: false
        }
      }
    },
    auditExecution: {
      pageSizes: [25, 50, 100, null],
      itemsjs: null,
      manipulators: {
        availableFilter: [
          AIM_IDS.FILTER_IMPORTANCE,
          AIM_IDS.FILTER_CATEGORY,
          AIM_IDS.FILTER_CHAPTER,
          AIM_IDS.FILTER_ANSWERD
        ],
        availableSortings: [
          AIM_IDS.SORT_IMPORTANCE,
          AIM_IDS.SORT_CATEGORY,
          AIM_IDS.SORT_CHAPTER,
          AIM_IDS.SORT_NO
        ],
        availableGrouping: [
          AIM_IDS.GROUP_CATEGORY,
          AIM_IDS.GROUP_IMPORTANCE,
          AIM_IDS.GROUP_CHAPTER
        ],
        defaultSorting: [
          {
            id: AIM_IDS.SORT_IMPORTANCE,
            desc: true
          }
        ],
        defaultGrouping: null
      }
    },
    auditWrapup: {
      pageSizes: [25, 50, 100, null],
      itemsjs: null,
      manipulators: {
        availableFilter: [
          AIM_IDS.FILTER_IMPORTANCE,
          AIM_IDS.FILTER_FINDING_IMPORTANCE,
          AIM_IDS.FILTER_CATEGORY,
          AIM_IDS.FILTER_CHAPTER,
          AIM_IDS.FILTER_ANSWERD
        ],
        availableSortings: [
          AIM_IDS.SORT_IMPORTANCE,
          AIM_IDS.SORT_FINDING_IMPORTANCE,
          AIM_IDS.SORT_CATEGORY,
          AIM_IDS.SORT_CHAPTER,
          AIM_IDS.SORT_NO
        ],
        availableGrouping: [
          AIM_IDS.GROUP_CATEGORY,
          AIM_IDS.GROUP_IMPORTANCE,
          AIM_IDS.GROUP_CHAPTER
        ],
        defaultSorting: [
          {
            id: AIM_IDS.SORT_IMPORTANCE,
            desc: true
          },
          {
            id: AIM_IDS.SORT_FINDING_IMPORTANCE,
            desc: false
          }
        ],
        defaultGrouping: null
      }
    },
    auditReporting: {
      pageSizes: [50, 100, 200, null],
      itemsjs: null,
      manipulators: {
        availableFilter: [
          AIM_IDS.FILTER_IMPORTANCE,
          AIM_IDS.FILTER_FINDING_IMPORTANCE,
          AIM_IDS.FILTER_CHAPTER,
          AIM_IDS.FILTER_CATEGORY,
          AIM_IDS.FILTER_ANSWERD
        ],
        availableSortings: [
          AIM_IDS.SORT_IMPORTANCE,
          AIM_IDS.SORT_FINDING_IMPORTANCE,
          AIM_IDS.SORT_CATEGORY,
          AIM_IDS.SORT_CHAPTER,
          AIM_IDS.SORT_NO
        ],
        availableGrouping: [
          AIM_IDS.GROUP_CATEGORY,
          AIM_IDS.GROUP_IMPORTANCE,
          AIM_IDS.GROUP_CHAPTER
        ],
        defaultSorting: [
          {
            id: AIM_IDS.SORT_FINDING_IMPORTANCE,
            desc: false
          }
        ],
        defaultGrouping: null
      }
    },
    templatePreperation: {
      pageSizes: [25, 50, 100, null],
      itemsjs: null,
      manipulators: {
        availableFilter: [
          AIM_IDS.FILTER_IMPORTANCE,
          AIM_IDS.FILTER_CHAPTER,
          AIM_IDS.FILTER_CATEGORY
        ],
        availableSortings: [
          AIM_IDS.SORT_IMPORTANCE,
          AIM_IDS.SORT_CATEGORY,
          AIM_IDS.SORT_CHAPTER,
          AIM_IDS.SORT_NO
        ],
        availableGrouping: [
          AIM_IDS.GROUP_CATEGORY,
          AIM_IDS.GROUP_IMPORTANCE,
          AIM_IDS.GROUP_CHAPTER
        ],
        defaultSorting: [
          {
            id: AIM_IDS.SORT_NO,
            desc: false
          }
        ],
        defaultGrouping: null
      }
    }
  };
}
